import { createSlice } from '@reduxjs/toolkit';

// utils
import actionUpdateConfigFunil from 'src/actions/chats/funil/actionUpdateConfigFunil';
import v2_actionListaChatsFunil from 'src/actions/v2/chats/funil/v2_actionListaChatsFunil';
import v2_actionCrmPesquisarLeads from 'src/actions/v2/crm/v2_actionCrmPesquisarLeads';
import v2_actionDetalhesLead from 'src/actions/v2/crm/v2_actionDetalhesLead';
import v2_actionListaColunasCrm from 'src/actions/v2/crm/v2_actionListaColunasCrm';
import v2_actionListaLeads from 'src/actions/v2/crm/v2_actionListaLeads';

// ----------------------------------------------------------------------

function objFromArray(array, key = 'id') {
  return array.reduce((accumulator, current) => {
    accumulator[current[key]] = current;
    return accumulator;
  }, {});
}

function objFromArrayId(array, key = '_id') {
  return array.reduce((accumulator, current) => {
    accumulator[current[key]] = current;
    return accumulator;
  }, {});
}

const initialState = {
  isLoading: false,
  error: false,
  colunas:[],
  lead:null,
  leadsKanban:null,
  ordemColunas:[]
};

const slice = createSlice({
  name: 'crm',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    persistCard(state, action) {
      const columns = action.payload;

      state.colunas = columns;
    },
    persistColumn(state, action) {
      state.ordemColunas = action.payload;
    },
    getListaLeadsFunilSuccess(state, action) {
      state.isLoading = false;
      if (Object.keys(objFromArrayId(action.payload)).length === 0) {
        state.leadsKanban = null;
    } else {
      state.leadsKanban = objFromArrayId(action.payload);
    }

      // state.leadsKanban = objFromArrayId(action.payload);
    },
    getDetalhesLeadSuccess(state, action) {
      state.isLoading = false;
      state.lead = action.payload;
    },
    setLeadData(state, action) {
      state.lead = action.payload;
    },
    getListaColunasCrmSuccess(state, action) {
      let listaColunas = action.payload;
      const reduce = listaColunas.map(item => item.id)
    
      state.isLoading = false;
      state.colunas = objFromArray(action.payload);
      state.ordemColunas = reduce;
    }
  }
});

// Reducer
export default slice.reducer;

export const { setLeadData } = slice.actions;

// ----------------------------------------------------------------------

// Guarda contra respostas obsoletas sobrescreverem dados mais recentes.
// Cada "canal" de estado (leads e colunas) registra a ordem de disparo das
// requisições e o id da última resposta já aplicada com sucesso. Uma resposta
// só é aplicada se for mais nova que a última aplicada — assim dois refreshes
// em sequência (ex.: dois drags seguidos no Kanban) nunca deixam a resposta
// antiga sobrescrever a nova, mas uma resposta antiga bem-sucedida ainda é
// aproveitada caso a requisição mais recente falhe (o erro não descarta dados
// bons já recebidos). A guarda só se aplica ao sucesso; o caso de erro apenas
// sinaliza hasError e não toca em leadsKanban/colunas.
//
// Os contadores são de módulo e, portanto, compartilhados por todos os
// consumidores que escrevem o mesmo estado (Negocios e ModalNovoNegocio). Isso
// é intencional: leadsKanban/colunas é uma célula global única, então "resposta
// mais nova vence" deve valer inclusive entre consumidores distintos.
function createStaleGuard() {
  let dispatchSeq = 0;
  let lastAppliedSeq = 0;
  return {
    nextId: () => (dispatchSeq += 1),
    shouldApply: (id) => {
      if (id <= lastAppliedSeq) return false;
      lastAppliedSeq = id;
      return true;
    },
  };
}

const leadsGuard = createStaleGuard();
const colunasGuard = createStaleGuard();

export function getListaLeads(querys) {
  const requestId = leadsGuard.nextId();
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await v2_actionListaLeads(querys);
      if (leadsGuard.shouldApply(requestId)) {
        dispatch(slice.actions.getListaLeadsFunilSuccess(response.data.data));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}



export function getListaColunasCrm(querys) {
  const requestId = colunasGuard.nextId();
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await v2_actionListaColunasCrm(querys);
      if (colunasGuard.shouldApply(requestId)) {
        dispatch(slice.actions.getListaColunasCrmSuccess(response.data.data));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getDetalhesLead(id) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await v2_actionDetalhesLead(id);
      dispatch(slice.actions.getDetalhesLeadSuccess(response.data.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}


export function persistColumn(newColumnOrder, user) {
  return async (dispatch) => {
    dispatch(slice.actions.persistColumn(newColumnOrder));
    try {
      
      
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
   
  };
}

export function getListaLeadsPesquisar(querys) {
  // Escreve o mesmo leadsKanban, então compartilha a guarda de leads para não
  // reintroduzir o bug de sobrescrita por resposta obsoleta.
  const requestId = leadsGuard.nextId();
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await v2_actionCrmPesquisarLeads(querys);
      if (leadsGuard.shouldApply(requestId)) {
        dispatch(slice.actions.getListaLeadsFunilSuccess(response.data.data));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function persistCard(columns) {
  return (dispatch) => {
    dispatch(slice.actions.persistCard(columns));
  };
}

